
import { useReducer, useRef, useCallback, useMemo } from 'react';

function logInConsole(actionType, action, previousState, state) {
    console.groupCollapsed(`${actionType}`);
    console.log('%c prev state', 'color: #686E69;', previousState);
    console.log('%c action', 'color: #007bff;', action);
    console.log('%c next state', 'color: #4CAF59', state);
    console.groupEnd();
}

function useCustomReducer(reducerFn, initialState, ignoreTypes = []) {

    const [state, dispatch] = useReducer(reducerFn, initialState);

    const preState = useRef();

    const dispatchWithLogging = useCallback((action) => {
        const actionType = (typeof action === 'object') ? action.type : action;
        preState.current = { ...preState.current, actionType, action };
        dispatch(action);
    }, []);

    useMemo(
        function logStateAfterChanging() {

            if (!preState.current) return;
            const { actionType, state: previousState, action } = preState.current;

            if (ignoreTypes.includes(action.type)) return;

            logInConsole(actionType, action, previousState, state);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [state]
    );

    preState.current = { ...preState.current, state };

    return [state, dispatchWithLogging];
}

export default useCustomReducer;
